import React from "react";
export const DeviceInfoIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props} // Allows passing down other SVG properties
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4 20.64H21.72H21.734C22.3237 20.6324 22.8 20.1518 22.8 19.56V13.08C22.8 12.4838 22.3161 12 21.72 12H17.4C16.8038 12 16.32 12.4838 16.32 13.08V19.56C16.32 20.1561 16.8038 20.64 17.4 20.64ZM14.16 17.4V13.08C14.16 11.2904 15.6104 9.83998 17.4 9.83998H20.64V6.59999C20.64 5.74031 20.2987 4.91626 19.6906 4.3093C19.0837 3.70126 18.2596 3.35999 17.4 3.35999H4.43995C3.58027 3.35999 2.75623 3.70126 2.14927 4.3093C1.54123 4.91626 1.19995 5.74031 1.19995 6.59999V14.16C1.19995 15.0197 1.54123 15.8437 2.14927 16.4507C2.75623 17.0587 3.58027 17.4 4.43995 17.4H9.83995V18.48H8.75995C8.16379 18.48 7.67995 18.9638 7.67995 19.56C7.67995 20.1561 8.16379 20.64 8.75995 20.64H13.08C13.6761 20.64 14.16 20.1561 14.16 19.56C14.16 18.9638 13.6761 18.48 13.08 18.48H12V17.4H14.16Z"
      />
    </svg>
  );
};
